export enum RoleTypes {
  PLANNER = 1,
  SERVICE_PROVIDER = 2,
  FINANCIAL_OFFICER = 3
}
